type ContentSectionProps = {
  children: React.ReactNode;
};

const ContentSection = ({ children }: ContentSectionProps) => (
  <section className="section">
    <div className="container is-max-desktop content">{children}</div>
  </section>
);

const ContentPage = ({ title, children }) => (
  <>
    <section className="hero is-primary">
      <div className="hero-body">
        <div className="container is-max-desktop">
          <h1 className="title">{title}</h1>
        </div>
      </div>
    </section>
    {children}
  </>
);

export { ContentPage, ContentSection };
